import * as React from 'react';

import { useCountdownTimer } from '../../../hooks/useCountdownTimer';
import TimerIcon from '../../icons/TimerIcon';
import TrophyIcon from '../../icons/TrophyIcon';
import UserIcon from '../../icons/UserIcon';

import styles from './BingoInfo.module.scss';

interface BingoInfoProps {
  bingoData: {
    numberOfPlayers: number;
    formattedPrize: string;
    startTime: number;
    currency: string;
    displayName: string;
  };
}

const BingoInfo = ({ bingoData }: BingoInfoProps) => {
  const {
    secondsRemaining,
    minutesRemaining,
    totalSecondsRemaining,
  } = useCountdownTimer(bingoData.startTime);

  return (
    <div className={styles.bingoInfo} data-testid="bingo-info">
      <h4 className={styles.title}>{bingoData.displayName}</h4>

      <ul>
        <li>
          <UserIcon />
          <span>{bingoData.numberOfPlayers}</span>
        </li>
        <li>
          <TrophyIcon />
          <span>{bingoData.formattedPrize}</span>
        </li>
        <li>
          <TimerIcon />
          <span>
            {totalSecondsRemaining > 10
              ? `${minutesRemaining}:${secondsRemaining}`
              : totalSecondsRemaining > 0
              ? 'Starting'
              : 'Closed'}
          </span>
        </li>
      </ul>
    </div>
  );
};

export default BingoInfo;
